import type { SVGProps } from 'react';
const DawnFlagBB = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BB_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BB_svg__a)">
      <path fill="url(#dawn-flag-BB_svg__b)" d="M0 0h22v16H0z" />
      <path fill="#08379D" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#08379D" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#FFCC50"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M10.739 5.223a.333.333 0 0 1 .557.006l.487.758a.268.268 0 0 1-.225.413.27.27 0 0 0-.267.294l.204 2.072c.017.17.16.3.332.3h.082a.33.33 0 0 0 .237-.098l.33-.331a.33.33 0 0 0 .096-.235v-.799a.33.33 0 0 0-.096-.234l-.056-.057a.333.333 0 0 1 .13-.55l.534-.18c.24-.082.48.125.435.375l-.362 2.005a.33.33 0 0 1-.095.18l-.917.896a.33.33 0 0 1-.233.095h-.054a.333.333 0 0 0-.334.334v.4c0 .184-.149.333-.333.333h-.381a.333.333 0 0 1-.333-.333v-.4a.333.333 0 0 0-.334-.334h-.05a.33.33 0 0 1-.238-.1l-.88-.895a.33.33 0 0 1-.089-.17l-.394-2.003a.333.333 0 0 1 .435-.38l.523.178a.333.333 0 0 1 .131.549l-.056.057a.33.33 0 0 0-.096.234v.799c0 .088.035.172.097.235l.33.331a.33.33 0 0 0 .236.099h.082c.172 0 .316-.13.332-.301l.204-2.076a.264.264 0 0 0-.263-.29.264.264 0 0 1-.22-.411z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-BB_svg__b"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1132C7" />
        <stop offset={1} stopColor="#0522A5" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagBB;
